var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 20C18.2091 20 20 18.2091 20 16C20 13.7909 18.2091 12 16 12C13.7909 12 12 13.7909 12 16C12 18.2091 13.7909 20 16 20Z",
    fill: "#2E356E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6775 14.9125C29.0238 12.355 26.8782 10.1825 24.4732 8.62938C21.8125 6.90938 18.875 6 15.9788 6C13.3213 6 10.7082 6.75938 8.2119 8.25688C5.66628 9.78375 3.36003 12.0144 1.3569 14.8862C1.13077 15.2108 1.00623 15.5953 0.999103 15.9908C0.991981 16.3863 1.1026 16.775 1.3169 17.1075C2.96753 19.6906 5.0919 21.8662 7.4594 23.3981C10.125 25.125 12.9938 26 15.9788 26C18.8982 26 21.8419 25.0981 24.4913 23.3925C26.895 21.8444 29.0363 19.6637 30.6838 17.085C30.8907 16.7602 31.0001 16.3829 30.999 15.9978C30.9979 15.6128 30.8863 15.2361 30.6775 14.9125ZM16 22C14.8133 22 13.6533 21.6481 12.6666 20.9888C11.6799 20.3295 10.9109 19.3925 10.4567 18.2961C10.0026 17.1997 9.8838 15.9933 10.1153 14.8295C10.3468 13.6656 10.9183 12.5965 11.7574 11.7574C12.5965 10.9182 13.6656 10.3468 14.8295 10.1153C15.9934 9.88378 17.1998 10.0026 18.2961 10.4567C19.3925 10.9108 20.3296 11.6799 20.9888 12.6666C21.6481 13.6533 22 14.8133 22 16C21.9982 17.5907 21.3655 19.1158 20.2407 20.2406C19.1158 21.3655 17.5908 21.9982 16 22Z",
    fill: "#2E356E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye_icon.9474aa70f8316173b161a0e27f71e36f.svg";
export { ForwardRef as ReactComponent };